export { SurgeonEntity } from './surgeon.entity';
export { SurgeonsRepository, surgeonsRepository } from './repository';
export type { ISurgeonsRepository } from './repository';
export { surgeonsKeys, useSurgeons, useCreateSurgeon, useUpdateSurgeon } from './hooks';
